export default {
      id: "mount-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#mount-usage",
      toString: function () {
        return this.url;
      }
    }